<template>
  <el-form class="progress-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="optionStyle">
      <template slot="label">
        <span class="require-flag">*</span>
        样式
      </template>
      <el-radio-group v-model="control.optionStyle">
        <el-radio label="条形">条形</el-radio>
        <el-radio label="环形">环形</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item prop="increase">
      <template slot="label">
        按钮
      </template>
      <el-checkbox v-model="control.increase">增加</el-checkbox>
      <el-checkbox v-model="control.reduce">减少</el-checkbox>
    </el-form-item>
    <el-form-item prop="step">
      <template slot="label">
        <span class="require-flag">*</span>
        步长
      </template>
      <div class="range">
        <el-input-number
          v-model="control.step"
          :controls="false"
          :max="100"
          :min="0"
          size="small"
          style="width: 100%"
        ></el-input-number>
        <span class="unit">%</span>
      </div>
    </el-form-item>
    <el-form-item prop="defaultVal">
      <template slot="label">
        默认值
      </template>
      <div class="range">
        <el-input-number
          v-model="control.defaultVal.value"
          :controls="false"
          :max="100"
          :min="0"
          size="small"
          style="width: 100%"
        ></el-input-number>
        <span class="unit">%</span>
      </div>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "progress-control",
  props: {
    control: Object
  }
}
</script>

<style lang="scss" scoped>
.progress-control {
  .range {
    position: relative;
    .unit {
      position: absolute;
      right: 5px;
    }
    ::v-deep {
      .el-input-number .el-input__inner {
        text-align: left;
      }
    }
  }
}
</style>
